import { useCallback, useState } from 'react'

/**
 * Filtro que sobrevive à navegação (docs/styleguide/03-componentes.md · 08): guardado em
 * `sessionStorage` sob `wx-<tela>-filter`.
 */
export function useStoredFilter<T extends string>(
  screen: string,
  allowed: readonly T[],
  fallback: T,
) {
  const key = `wx-${screen}-filter`
  const read = (): T | null => {
    try {
      const raw = window.sessionStorage.getItem(key)
      return raw && (allowed as readonly string[]).includes(raw) ? (raw as T) : null
    } catch {
      return null
    }
  }
  const [stored, setStored] = useState<T | null>(read)
  const setFilter = useCallback(
    (value: T) => {
      setStored(value)
      try {
        window.sessionStorage.setItem(key, value)
      } catch {
        /* sem storage */
      }
    },
    [key],
  )
  return { filter: stored ?? fallback, setFilter }
}
